import React from 'react';
import { type IntlShape } from 'react-intl-next';

import SuccessIcon from '@atlaskit/icon/core/status-success';
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { type Flag } from '../../../types';

import {
	MICROSOFT_SERVICE,
	GOOGLE_SERVICE,
	PLATFORM_SLACK_SERVICE,
} from '../../ThirdParty/constants';
import { messages } from '../../i18n';

export const getSuccessIntegrationFlag = (
	serviceKey: string,
	intl: IntlShape,
	workspace?: string,
): Flag => {
	let title: React.ReactNode;
	let description: React.ReactNode;

	switch (serviceKey) {
		case PLATFORM_SLACK_SERVICE:
			title = intl.formatMessage(messages.slackConnectSuccessFlagTitle, {
				workspace,
			});
			description = intl.formatMessage(messages.slackConnectSuccessFlagDescription);
			break;
		case MICROSOFT_SERVICE:
			title = intl.formatMessage(messages.microsoftConnectSuccessFlagTitle);
			description = intl.formatMessage(messages.microsoftConnectSuccessFlagDescription);
			break;
		case GOOGLE_SERVICE:
			title = intl.formatMessage(messages.googleConnectSuccessFlagTitle);

			description = intl.formatMessage(messages.googleConnectSuccessFlagDescription);
			break;
	}

	return {
		appearance: 'success',
		icon: (
			<SuccessIcon
				label="success"
				spacing="spacious"
				color={token('color.icon.success', colors.G400)}
			/>
		),
		title,
		description,
	};
};

export const getSlackDisconnectedFlag = (intl: IntlShape): Flag => {
	return {
		appearance: 'success',
		icon: (
			<SuccessIcon
				label="success"
				spacing="spacious"
				color={token('color.icon.success', colors.G400)}
			/>
		),
		title: intl.formatMessage(messages.slackDisconnectSuccessFlagTitle),
		description: intl.formatMessage(messages.slackDiscnnectSuccessFlagDescription),
	};
};
